module.exports = "https://static.wmbcdn.com/uniweb/images/4d53e07b9bcb1d1058c77b4015f34265.svg";